import Image from 'next/image';

import BigArrow from '@/fo/icons/base/icons/big-arrow.svg';
import StarIcon from '@/fo/icons/base/icons/star24.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitLabelBase, UiKitLabelBaseProps } from '@/fo/ui/kit/label/base';

import { RubricArticle } from '../../types';

import { styles } from './ArticleTile.styles';

export interface ArticleTileProps {
  article: RubricArticle;
  readArticle: string;
}

export function ArticleTile({ article, readArticle }: ArticleTileProps) {
  const slots = styles();

  return (
    <div className={slots.base()}>
      <div className={slots.imageContainer()}>
        <Image
          src={article.imageUrl}
          alt={article.title}
          fill
          className={slots.image()}
        />

        <div className={slots.meta()}>
          {article.meta.date && (
            <div className={slots.metaItem()}>
              {article.meta.readTime && (
                <>
                  <div>{article.meta.readTime}</div>
                  <div>/</div>
                </>
              )}
              <div>{article.meta.date}</div>
            </div>
          )}

          {!!article.meta.rating && (
            <div className={slots.metaItem()}>
              <StarIcon className={slots.metaItemIcon()} />
              {article.meta.rating}
            </div>
          )}
        </div>

        <div className={slots.tags()}>
          {article.tags.map((tag) => {
            const labelProps = {
              ...(tag.color && {
                style: {
                  backgroundColor: tag.color,
                  color: '#fff'
                }
              }),
              ...(tag.url && {
                href: tag.url,
                as: 'link' as const
              })
            } as UiKitLabelBaseProps;

            return (
              <UiKitLabelBase
                key={tag.id}
                uppercase
                color="yellow"
                {...labelProps}
              >
                {tag.title}
              </UiKitLabelBase>
            );
          })}
        </div>
      </div>

      <div className={slots.content()}>
        <div className={slots.title()}>{article.title}</div>
        <div className={slots.description()}>{article.description}</div>
        <UiKitButtonBase
          as="link"
          href={article.url}
          className={slots.button()}
          childrenClassName={slots.buttonChildren()}
          color="ghost"
        >
          <span>{readArticle}</span> <BigArrow />
        </UiKitButtonBase>
      </div>
    </div>
  );
}
